module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/object-to-processing-6b71c60f758f835c55d3b653d098e078.svg";